import { render, staticRenderFns } from "./CompletedCaseTasks.vue?vue&type=template&id=51efc880&scoped=true&"
import script from "./CompletedCaseTasks.vue?vue&type=script&lang=js&"
export * from "./CompletedCaseTasks.vue?vue&type=script&lang=js&"
import style0 from "./CompletedCaseTasks.vue?vue&type=style&index=0&id=51efc880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51efc880",
  null
  
)

export default component.exports